import {
  SET_SEARCHING,
  SET_EXPORTING,
  SET_RENT_LIST,
  SET_RENT_QUERY,
  SET_RENT_PAGETOTAL,
  SET_RENT_PAGE_NUM,
  SET_RENT_PAGE_SIZE,
} from './mutation-types'
import api from '@/api'
import files from 'file-saver'
import {objectTrim, getHeaderName} from '@/utils'
import { checkUserName } from '@/views/User/utils'
import { i18n } from '@/i18n'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  userId: '',
  userName: '',
})

const state = {
  searching: false,
  exporting: false,
  initQuery: initQuery(),
  rentDetail: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_EXPORTING] (state, payload) {
    state.exporting = payload
  },
  [SET_RENT_LIST] (state, payload) {
    state.rentDetail.list = payload
  },
  [SET_RENT_QUERY] (state, payload) {
    state.rentDetail.query = {
      ...state.rentDetail.query,
      ...payload,
    }
  },
  [SET_RENT_PAGETOTAL] (state, payload) {
    state.rentDetail.listPageTotal = payload
  },
  [SET_RENT_PAGE_NUM] (state, payload) {
    state.rentDetail.query.pageNum = payload
  },
  [SET_RENT_PAGE_SIZE] (state, payload) {
    state.rentDetail.query.pageSize = payload
  },
}

const actions = {
  // 初始化租赁明细
  initList ({dispatch}) {
    dispatch('setPageNum', 1)
  },
  // 获取租赁明细
  async getList ({commit, state, dispatch}, payload) {
    try {
      let param = {
        ...objectTrim(state.rentDetail.query),
        ...payload,
      }
      if (payload && !payload.userName && param.userName) {
        delete param.userName
      }
      commit(SET_SEARCHING, true)
      const {data, code} = await api.packApi.queryNodeRentals(param)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = param
          dispatch('getList', {
            ...other,
            userId,
          })
        },
      })

      if (data) {
        commit(SET_RENT_PAGE_NUM, data.pageNum || 1)
        commit(SET_RENT_PAGETOTAL, data.total || 0)
        commit(SET_RENT_LIST, data.items || [])
        commit(SET_RENT_PAGE_SIZE, data.pageSize || 50)
      }
    } catch (error) {
      commit(SET_RENT_PAGETOTAL, 0)
      commit(SET_RENT_LIST, [])
    }
    commit(SET_SEARCHING, false)
  },
  // 导出租赁明细
  async exportExcel ({commit, dispatch}, payload) {
    let params = {
      ...objectTrim(state.rentDetail.query),
      ...payload,
    }
    if (payload && payload.userId && params.userName) {
      delete params.userName
    }
    commit(SET_EXPORTING, true)
    const res = await api.packApi.exportNodeRentals(params)
    const {data, headers} = res
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = params
            dispatch('exportExcel', {
              ...other,
              userId,
            })
          },
        })
        if (code === 700) {
          // eslint-disable-next-line no-undef
          vm.$message({
            message: i18n.t(`api_${code}`),
            type: 'error',
          })
        }
      }
      reader.readAsText(res.data)
    }
    commit(SET_EXPORTING, false)
  },
  async editRent ({commit}, payload) {
    const {result, code} = await api.packApi.addOrUpdateNodeRental(payload)
    return {result, code}
  },
  async deleteRent ({commit}, payload) {
    const {result, code} = await api.packApi.deleteNodeRental(payload)
    return {result, code}
  },
  setQuery ({commit, state}, payload) {
    commit(SET_RENT_QUERY, payload)
  },
  setPageSize ({commit, dispatch}, payload) {
    commit(SET_RENT_PAGE_SIZE, payload)
    commit(SET_RENT_PAGE_NUM, 1)
    // dispatch('getList')
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_RENT_PAGE_NUM, payload)
    // dispatch('getList')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
